import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ClientService} from '../../../shared/services/client.service';
import {ClientDtoModel} from '../../../shared/models/client.dto.model';
import {LoaderService} from '../../../shared/services/loader.service';
import {UntypedFormBuilder, Validators} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import {LocalizationService} from '../../../shared/services/localization.service';
import {MessageService} from 'primeng/api';
import {PreferencesServices} from '../../../shared/services/preferences.services';
import {PreferenceDtoModel} from '../../../shared/models/preference.dto.model';

@Component({
    selector: 'njoy-detail-client',
    templateUrl: './detail-client.component.html',
    styleUrls: ['./detail-client.component.css']
})
export class DetailClientComponent implements OnInit {

    public uuidClient: string;
    public client: ClientDtoModel;
    public clientParraine = [];
    public matcher = new ErrorStateMatcher();
    public clientForm;

    public allPreferences = [];


    private VALID_PHONE_NUMBER_REGEX = '^(?:(?:\\+|00)33|0)\\s*[6|7](?:[\\s.-]*\\d{2}){4}$';

    public isMale = false;
    public isFemale = false;
    public isOther = true;

    constructor(private route: ActivatedRoute,
                private clientService: ClientService,
                private preferencesService: PreferencesServices,
                private loaderService: LoaderService,
                private formBuilder: UntypedFormBuilder,
                private localizationService: LocalizationService,
                private messageService: MessageService) {
    }

    ngOnInit(): void {
        this.fetchPreferencesValues();
        this.initEmptyForm();
    }

    private fetchPreferencesValues() {
        this.preferencesService.findAllPreferences().subscribe((prefs: PreferenceDtoModel[]) => {
            prefs.forEach((pref: PreferenceDtoModel) => {
                this.allPreferences.push({
                    value: pref.label,
                    displayedValue: this.localizationService.translate('PREFRENCES.' + pref.label)
                });
            });
            this.uuidClient = this.route.snapshot.paramMap.get('clientUuid');
            this.getClientByUuid();
        });
    }

    private initEmptyForm() {
        this.clientForm = this.formBuilder.group({
            firstName: ['', [
                Validators.required
            ]],
            lastName: ['', [
                Validators.required
            ]],
            sponsorshipCode: [{value: '', disabled: true}],
            email: ['', [
                Validators.required,
                Validators.email
            ]],
            phoneNumber: ['', [
                Validators.required,
                Validators.pattern(this.VALID_PHONE_NUMBER_REGEX)
            ]],
            birthDate: ['', [
                Validators.required
            ]],
            creationDate: [{value: '', disabled: true}],
            zipCode: ['', []],
            preference: [''],
        });
    }

    get getControl() {
        return this.clientForm.controls;
    }

    private getClientByUuid(): void {
        this.loaderService.startLoading();
        this.clientService.getClientByUuid(this.uuidClient).subscribe(
            (data: ClientDtoModel) => {
                this.loaderService.stopLoading();
                this.client = data;
                this.setGender(this.client.sexe.toLowerCase())
                this.setValues();
            }, (err: any) => {
                this.loaderService.stopLoading();
                console.log('error while getting client..');
                console.log(err);
            }
        );
    }

    private setValues(): void {
        this.clientForm = this.formBuilder.group({
            firstName: [this.client.firstName, [
                Validators.required
            ]],
            lastName: [this.client.lastName, [
                Validators.required
            ]],
            sponsorshipCode: [{value: this.client.sponsorshipCode, disabled: true}],
            email: [this.client.email, [
                Validators.required,
                Validators.email
            ]],
            phoneNumber: [this.client.phoneNumber, [
                Validators.required, Validators.pattern(this.VALID_PHONE_NUMBER_REGEX)
            ]],
            birthDate: [this.client.birthDate, [
                Validators.required
            ]],
            creationDate: [{value: this.client.creationDate, disabled: true}],
            zipCode: [this.client.zipCode],
            preference: [this.getPersistedPreferences()],
        });
    }

    public updateClient(): void {
        if (this.clientForm.status === 'VALID') {
            this.loaderService.startLoading();
            this.patchValues();
            this.clientService.updateClient(this.client).subscribe(
                () => {
                    this.loaderService.stopLoading();
                    this.displaySuccessMessage('CLIENT.SUCCESS_SUMMARY', 'CLIENT.UPDATE_SUCCESS_DETAIL');
                }, (err: any) => {
                    this.loaderService.stopLoading();
                    console.log('error while updating client..');
                    console.log(err);

                });
        }
    }

    private patchValues(): void {
        this.client.firstName = this.clientForm.value.firstName;
        this.client.lastName = this.clientForm.value.lastName;
        this.client.email = this.clientForm.value.email;
        this.client.phoneNumber = this.clientForm.value.phoneNumber;
        this.client.birthDate = this.clientForm.value.birthDate;
        this.client.zipCode = this.clientForm.value.zipCode;
        this.client.preferences = this.clientForm.value.preference.map(value => value.value);
        this.client.sexe = this.isMale ? 'MALE' : (this.isFemale ? 'FEMALE' : 'OTHER');
    }


    private displaySuccessMessage(summary: string, detail: string): void {
        this.messageService.add({
            severity: 'success',
            summary: this.localizationService.translate(summary),
            detail: this.localizationService.translate(detail)
        });
    }

    private getPersistedPreferences(): any[] {
        const tab = [];
        this.allPreferences.forEach((val: any) => {
            this.client.preferences.forEach((pref: any) => {
                if (val.value === pref) {
                    tab.push(val);
                }
            })
        });

        return tab;
    }

    public setGender(gender: string): void {
        if (gender === 'male') {
            this.isMale = true;
            this.isFemale = false;
            this.isOther = false;
        } else if (gender === 'female') {
            this.isMale = false;
            this.isFemale = true;
            this.isOther = false;
        } else {
            this.isMale = false;
            this.isFemale = false;
            this.isOther = true;
        }
    }
}
